<template>
  <div class="adx flex flex-wrap min-h-[93vh]">
    <!--  main -->
    <div class="flex-1 lg:min-w-[800px] sm:min-w-full min-h-[50vh]">
      <div class="mx-auto mt-[0.5em] max-w-[1100px] p-4">
        <!--   stages tabs -->
        <div class="mb-6">
          <h2 class="sr-only">Steps</h2>
          <div id="steps">
            <ul class="stepList grid grid-cols-1 divide-x divide-gray-100 overflow-hidden rounded border border-gray-100 text-sm text-gray-500 sm:grid-cols-3">
              <li v-for="option in stepOptions" class="stageItem cursor-pointer relative flex items-center justify-between p-4 hover:bg-[#ececec] transition-all duration-500 ease-in-out group" style="margin: 0" :class="stage === option.step ? 'activeStage' : ( stage > option.step ? 'completeStage' : '')" @click="stage = option.step">
                <span v-if="option.step === 2" class="absolute -left-2 top-1/2 hidden h-4 w-4 -translate-y-1/2 rotate-45 border border-b-0 border-l-0 border-gray-100 bg-white sm:block group-hover:bg-[#ececec] transition-all duration-500 ease-in-out" :class="stage === 1 ? 'activeStage': (stage >= 2 ? 'completeStage' : '')"></span>
                <span v-if="option.step === 2" class="absolute -right-2 top-1/2 hidden h-4 w-4 -translate-y-1/2 rotate-45 border border-b-0 border-l-0 border-gray-100 bg-white sm:block z-[1] group-hover:bg-[#ececec] transition-all duration-500 ease-in-out" :class="stage === 2 ? 'activeStage' : (stage > 2  ? 'completeStage'  : '')"></span>
                <p class="leading-none">
                  <strong class="block">{{ option.label }}</strong>
                  <span class="text-sm">{{ option.description }}</span>
                </p>
                <i :class="option.icon" class="text-4xl ml-2" />
              </li>
            </ul>
          </div>
        </div>

        <!--    main section    -->
        <transition name="slide-fade" mode="out-in">

          <!--    Course Details    -->
          <div v-if="stage === 1" id="1">
            <h2>Course Details</h2>

            <div class="relative mt-6 mb-3">
              <input v-model="courseName" id="id-l01" type="text" name="id-l01" placeholder="your name" class="relative w-full h-12 px-4 shadow-md placeholder-transparent transition-all border rounded outline-none focus-visible:outline-none peer border-slate-200 text-slate-500 autofill:bg-white focus:border-emerald-500 focus:outline-none" style="background: white; border-radius: 4px" />
              <label for="id-l01" class="cursor-text peer-focus:cursor-default peer-autofill:-top-2 absolute left-2 -top-2 z-[1] px-2 text-xs text-slate-400 transition-all before:absolute before:top-0 before:left-0 before:z-[-1] before:block before:h-full before:w-full before:bg-white before:transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-xs peer-focus:text-primary peer-disabled:before:bg-transparent">Course Name</label>
            </div>

            <div v-if="isIncludeDED" class="grid grid-cols-2 gap-6">
              <div class="border-slate-200 text-center border shadow-md rounded p-8 mb-4">
                <div class="text-xl text-primary font-bold">Course Budget (hours, including DED Course Build)</div>
                <div class="flex my-auto p-2">
                  <button class="rounded-full btn-primary" @click="budget !== 0 ? budget-- : ''" :disabled="budget === 0">-</button>
                  <input class="calcInput border border-primary" type="number" v-model="budget" />
                  <button class="rounded-full btn-primary" @click="budget++">+</button>
                </div>

                <p>Leave zero if not applicable.</p>
              </div>

              <div class="border-slate-200 text-center border shadow-md rounded p-8 mb-4">
                <div class="text-xl text-primary font-bold">Course Length (weeks)</div>
                <div class="flex my-auto p-2">
                  <button class="rounded-full btn-primary" @click="courseWeeks--" :disabled="courseWeeks === 0">-</button>
                  <input class="calcInput border border-primary" type="number" v-model="courseWeeks" />
                  <button class="rounded-full btn-primary" @click="courseWeeks++">+</button>
                </div>
                <p>Leave zero if not applicable.</p>
              </div>
            </div>

            <div v-else class="border-slate-200 text-center border shadow-md rounded p-8 mb-6">
              <div class="text-xl text-primary font-bold">Course Budget (hours)</div>
              <div class="flex justify-center my-auto p-2">
                <button class="rounded-full btn-primary" @click="budget !== 0 ? budget-- : ''" :disabled="budget === 0">-</button>
                <input class="calcInput border border-primary" style="width: 40%" type="number" v-model="budget" />
                <button class="rounded-full btn-primary" @click="budget++">+</button>
              </div>

              <p>Leave zero if not applicable.</p>
            </div>

            <div class="flex justify-between my-2">
              <div class="relative flex flex-wrap items-center h-fit my-auto">
                <input :checked="isIncludeDED" class="relative w-12 h-6 transition-colors appearance-none cursor-pointer hover:bg-slate-400 after:hover:bg-slate-600 checked:hover:bg-emerald-300 checked:after:hover:bg-emerald-600 focus:outline-none checked:focus:bg-emerald-400 checked:after:focus:bg-emerald-700 focus-visible:outline-none peer rounded-xl bg-slate-300 after:absolute after:top-0 after:left-0 after:h-6 after:w-6 after:rounded-full after:bg-slate-500 after:transition-all checked:bg-emerald-200 checked:after:left-6 checked:after:bg-emerald-500" type="checkbox" style="border: 0 !important;" id="id-c04" @click="updateIncludeDED" />
                <label class="pl-2 cursor-pointer text-slate-500" for="id-c04">Include DED Course Build</label>
              </div>

              <button class="btn-secondary float-right uppercase my-auto" @click="stage++">Next<i class="fas fa-caret-right ml-2" />
              </button>
            </div>
          </div>

          <!--    Media Items    -->
          <div v-else-if="stage === 2" id="2">
            <h2>Media Items</h2>
            <!--            accordions-->
            <vue-collapsible-panel-group accordion class="panelGroup mt-6">
              <vue-collapsible-panel :expanded="index === 0" class="panel" v-for="(type, index) in MEDIA_TYPES" v-show="type.name !== 'Build' || isIncludeDED" :ref="setItemRef">
                <template #title>
                  <div class="flex w-full justify-between">
                    <h2 style="font-size: 120%" :style="'border-color: ' + colours[index]">{{ type.name }}</h2>
                  </div>
                </template>
                <template class="panelContent" #content>
                  <p>&nbsp;</p> 
                  <!-- I hate this, but sneaky test for production use of a computed value -->

                  <div v-if="type.name === 'Build'" class="ml-1 mt-2">
                    <strong>Course Build</strong> and <strong>Review Changes</strong>
                    have been filled in based on your course length entered earlier.
                  </div>
                  <table class="adx w-full">
                    <thead>
                      <tr>
                        <th>Item Type</th>
                        <th style="text-align: center"># of items</th>
                        <th style="text-align: center">Hours</th>
                        <th v-if="type.name === 'Videos'" style="text-align: center">Studio bookings needed</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in mappedItems.filter(i => i.type === type.name)">
                        <td class="p-2">
                          <div class="font-bold">{{ item.name }}</div>
                          <div class="text-sm text-gray-600">{{ item.description }}</div>
                        </td>
                        <td v-if="['bcb', 'bch'].includes(item.slug)">
                          <div class="flex justify-center h-[60px] font-bold text-primary text-xl">
                            <span class="text-center my-auto">{{ item.count }}</span>
                          </div>
                        </td>
                        <td v-else>
                          <div class="flex w-[120px] m-auto align-middle p-1">
                            <button style="padding: 0; width: 60px" class="rounded-full btn-primary mr-1" @click="media[item.slug]--" :disabled="media[item.slug] === 0">-</button>
                            <input class="listInput" type="number" v-model="media[item.slug]" :disabled="['bcb', 'bch'].includes(item.slug)" style="font-size: 1.5em; padding: 8px" />
                            <button style="padding: 0; width: 60px" class="rounded-full btn-primary ml-1" @click="media[item.slug]++">+</button>
                          </div>
                        </td>
                        <td>
                          <div class="flex justify-center h-[60px]">
                            <span class="text-center my-auto" :class="item.totalHours ? '' : 'text-gray-200'">{{ item.totalHours }}</span>
                          </div>
                        </td>

                        <td v-if="item.type === 'Videos'">
                          <div class="flex justify-center h-[60px]">
                            <span class="text-center my-auto" :class="item.slug !== 'vpp' && item.studioBookings ? 'font-bold' : 'text-gray-200'">{{ item.studioBookings }}</span>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="type.name === 'Videos' && videoCount">
                        <td colspan="4">
                          <strong> * Based on these video assets, you will require {{ videoCount }} transcripts.</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </vue-collapsible-panel>
            </vue-collapsible-panel-group>

            <div class="flex justify-between my-2">
              <button class="btn-secondary float-right uppercase my-auto" @click="stage--"><i class="fas fa-caret-left mr-2" />Back</button>
              <button class="btn-secondary float-right uppercase my-auto" @click="stage++">Next<i class="fas fa-caret-right ml-2" /></button>
            </div>
          </div>


          <!--    Export    -->
          <div v-else-if="stage === 3" id="3">
            <h2>Export</h2>
            <p>Select desired export or share method</p>
            <div class="flex justify-between border-gray-100 text-center border shadow-md rounded p-8 my-4">
              <div class="flex">
                <i class="far fa-file-csv text-2xl my-auto" />
                <span class="font-bold ml-2 my-auto">Scope of Work (.CSV)</span>
              </div>
              <button class="btn-secondary uppercase w-[120px] h-[50px]" @click="exportCSV">Download</button>
            </div>
            <div class="flex justify-between border-gray-100 text-center border shadow-md rounded p-8 my-4">
              <div class="flex">
                <i class="far fa-share-alt text-2xl my-auto" />
                <span class="font-bold ml-2 my-auto">Shared Link</span>
              </div>
              <button class="btn-secondary uppercase w-[120px] h-[50px] disabled:bg-lime-600 disabled:hover:text-white" @click="copyLink" :disabled="copied">{{ copied ? 'Copied' : 'Copy' }}</button>
            </div>

            <div class="flex justify-between my-2">
              <button class="btn-secondary float-right uppercase my-auto" @click="stage--">
                <i class="fas fa-caret-left mr-2" />Back
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!--  end slides + interaction -->

    <!--  sidebar-->
    <div class="sidebar sticky top-0 flex-1 bg-primary-darker text-white border-l-primary border-l-4 z-10">
      <div class="grow md:w-[50%] lg:w-full">
        <div class="text-center">
          <div class="mb-3 text-2xl"><strong>Summary</strong></div>
          <div class="m-2 text-[#99BDD7] font-bold">{{ courseName }}</div>

          <div class="columns-2 text-sm">
            <div><strong>Budget</strong> (hrs)</div>
            <div class="text-[#99BDD7] text-xl">{{ budget }}</div>

            <div><strong>Length</strong> (weeks)</div>
            <div class="text-[#99BDD7] text-xl">{{ courseWeeks }}</div>
          </div>
        </div>
        <h2 style="font-size: 16px">Budget Usage</h2>
        <div class="text-center text-base m-2 leading-8">
          <div><strong>Total Hour(s):</strong>
            <span class="text-[#99BDD7] ml-1">{{ totalHours }} out of  {{ budget }}</span> in use
          </div>
          <div v-if="budget && totalHours <= budget"><strong>Hour(s) Remaining:</strong>
            <span class="text-green-400 ml-1">{{ budget - totalHours }}</span> left to allocate
          </div>
          <div v-if="budget && totalHours > budget"><strong>Hour(s) Over Budget:</strong>
            <span class="text-red-400 ml-1">{{ totalHours - budget }} or {{ Math.round((totalHours - budget) / budget * 100) }}%</span>
          </div>
        </div>

        <h2 style="font-size: 16px; margin-bottom: -20px">Planned Hours</h2>

        <!--      graph-->
        <div class="flex justify-center md:w-[80%] lg:w-full h-[300px]">
          <div id="chartDiv" class="h-[250px] w-full mt-10" />
        </div>

        <div :class="wrapperClass">
          <table class="w-full -mt-2">
            <thead>
              <tr class="text-sm" style="border-bottom: 1px solid #d40000">
                <th class="w-1/3 text-left">Activity</th>
                <th class="w-1/3 text-center">Hours</th>
                <th class="w-1/3 text-center">Story Points</th>
              </tr>
            </thead>
            <template v-for="type in summaryTableData">
              <tr class="text-sm" style="border-bottom: 1px dotted #ffffff">
                <td class="font-bold">
                  <div class="my-2">{{ type.name }}</div>
                </td>
                <td class="flex justify-center">
                  <div class="my-2 font-bold">{{ type.hours }}</div>
                </td>
                <td>
                  <div class="flex justify-center">
                    <span class="bg-gray-300 text-gray-500 text-xs font-bold leading-5 text-center rounded-full w-5 h-5">{{ type.storyPoints }}</span>
                  </div>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
    </div>
    <!--  end sidebar-->
  </div>
</template>

<script setup>
//Imports
import { ref, onMounted, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { MEDIA_TYPES, MEDIA_ITEMS } from "@/assets/consts";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import rison from "rison"; // URI minimisation
import INPUT from "@/assets/input.json";

const router = useRouter();
const route = useRoute();

const wrapperClass = "max-w-[80%] mx-auto mt-5"

const stepOptions = [
  { step: 1, label: 'Course Details', description: 'Course name, budget, and length', icon: 'far fa-edit' },
  { step: 2, label: 'Media Items', description: 'Select the required media assets', icon: 'far fa-photo-video' },
  { step: 3, label: 'Export', description: 'Select export type', icon: 'far fa-download' },
]

//hardcoded from style guide - had trouble passing through dynamic colours
const colours = ["#c373f9", "#4cc9f0", "#90be6d", "#f8961e", "#fa6769", "#d40000"];
const chartCategories = [
  { name: 'LRD', color: '#4cc9f0' },
  { name: 'VID', color: '#90be6d' },
  { name: 'DED', color: '#d40000' },
]

const stage = ref(1); //stage tracker - each tab
const itemRefs = ref([]);
const isIncludeDED = ref(false);
const media = ref(INPUT);
const copied = ref(false);
const courseName = ref("");
const courseWeeks = ref(0);
const budget = ref(0);
let chart, innerSeries, outerSeries, chartLabel;

let loadURI = async () => {
  //get the URI params and read the data from the shared link
  //router is async, so we wait for it to be ready
  await router.isReady();
  //if there is a data param we decode it and update the values
  if (route.query.data) {
    let data = rison.decode(route.query.data);
    isIncludeDED.value = data.includeDED ?? false;
    media.value = data.media;
    courseWeeks.value = data.courseWeeks ?? 0;
    budget.value = data.budget ?? 0;
    courseName.value = data.courseName ?? "";
  }
};

const mappedItems = computed(() => {
  return MEDIA_ITEMS.map(item => {
    let count = media.value[item.slug] ?? 0
    if (['bcb', 'bch'].includes(item.slug) && courseWeeks.value > 0) {
      count = item.slug === 'bcb' ? courseWeeks.value + 1 : courseWeeks.value
    }
    const totalHours = count * item.hoursPer
    return {
      ...item,
      count,
      totalHours,
      storyPoints: calcStoryPoints(totalHours),
      studioBookings: ['vln', 'viv', 'vlc'].includes(item.slug) ? calcStudioBooking(item.slug, totalHours) : 0,
      color: colours[MEDIA_TYPES.findIndex(t => t.name === item.type)],
    };
  });
})

const videoCount = computed(() => {
  return mappedItems.value.filter(i => i.type === 'Videos').reduce((acc, item) => acc + item.count, 0)
})

const totalHours = computed(() => {
  return mappedItems.value.filter(i => i.team !== 'DED' || isIncludeDED.value).reduce((acc, item) => acc + item.totalHours, 0)
})

const summaryTableData = computed(() => {
  return MEDIA_TYPES.filter(t => t.name !== 'Build' || isIncludeDED.value).map(type => {
    const hours = mappedItems.value.filter(i => i.type === type.name).reduce((acc, item) => acc + item.totalHours, 0)
    return {
      name: type.name,
      hours,
      storyPoints: calcStoryPoints(hours)
    }
  })
})

const innerChartData = computed(() => {
  let data = chartCategories.map(category => {
    return {
      name: category.name,
      value: mappedItems.value.filter(i => i.team === category.name).reduce((acc, item) => acc + item.totalHours, 0),
      settings: { fill: am5.color(category.color) }
    }
  })
  if (budget.value > totalHours.value) {
    data.push({
      name: 'Unused',
      value: budget.value - totalHours.value,
      settings: { fill: am5.color('#9fa8ae') }
    })
  }
  return data.filter(d => d.value > 0)
})

const outerChartData = computed(() => {
  if (!budget.value && !totalHours.value) {
    return [{
      name: '',
      value: 1,
      settings: { fill: am5.color('#9fa8ae'), tooltipText: '' }
    }]
  }
  let itemIndex = 0
  let itemType = ''
  let data = mappedItems.value.sort((a, b) => chartCategories.findIndex(c => c.name === a.team) - chartCategories.findIndex(c => c.name === b.team))
  .filter(item => item.totalHours > 0)
  .map(item => {
    if (item.type !== itemType) {
      itemIndex = 0
      itemType = item.type
    } else {
      itemIndex++
    }
    return {
      name: item.type + ' -\n' + item.name,
      value: item.totalHours,
      settings: { fill: am5.color(newShade(item.color, itemIndex * (-15))) }
    }
  })
  if (budget.value > totalHours.value) {
    data.push({
      name: 'Unused',
      value: budget.value - totalHours.value,
      settings: { fill: am5.color('#9fa8ae') }
    })
  }
  return data.filter(d => d.value > 0)
})

// FUNCTIONS
function calcStudioBooking (slug, hours) {
  return slug === 'vlc' ? Math.ceil(hours / 4) : Math.ceil(hours / 6)
}

function calcStoryPoints (hours) {
  switch (true) {
    case hours === 0:
      return 0;
    case hours < 2:
      return 1; //a morning/couple hours
    case hours < 4:
      return 2; //half a day
    case hours < 8:
      return 3; // a day
    case hours < 14:
      return 5; // couple days
    case hours < 21:
      return 8; // a few days
    case hours <= 36:
      return 13; // ~week
    default:
      return 21; // over a week - that's as far as we can plan ahead for
  }
}

function setItemRef (el) {
  if (el) {
    itemRefs.value.push(el);
  }
}

function exportCSV () {
  //save userData as a CSV
  let csvContent = "data:text/csv;charset=utf-8,";
  csvContent += "type,item,description,item count,hours,story points,team";
  csvContent += "\n";

  MEDIA_TYPES.filter(t => t.name !== 'Build' || isIncludeDED.value).forEach(type => {
    mappedItems.value.filter(i => i.type === type.name).forEach(item => {
      csvContent +=
        type.name +
        "," +
        item.name +
        "," +
        item.description +
        "," +
        item.count +
        "," +
        item.totalHours +
        "," +
        calcStoryPoints(item.totalHours) +
        "," +
        item.team +
        ",";
      csvContent += "\n";
    })
  })
  let encodedUri = encodeURI(csvContent);
  let link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "scope_of_work.csv");
  document.body.appendChild(link); // Required for FF
  //click link
  link.click();
}

function updateURL () {
  copied.value = false;
  let data = {
    media: media.value,
    budget: budget.value,
    courseWeeks: courseWeeks.value,
    courseName: courseName.value,
    includeDED: isIncludeDED.value,
  };
  //encode the json object into a rison string
  let risonString = rison.encode(data);
  //update the query params
  router.push({ query: { data: risonString } });
}

function copyLink () {
  //update the query params
  navigator.clipboard.writeText(
    window.location.href
  );
  copied.value = true;
}

function newShade (hexColor, magnitude) {
  hexColor = hexColor.replace(`#`, ``);
  if (hexColor.length === 6) {
    const decimalColor = parseInt(hexColor, 16);
    let r = (decimalColor >> 16) + magnitude;
    r > 255 && (r = 255);
    r < 0 && (r = 0);
    let g = (decimalColor & 0x0000ff) + magnitude;
    g > 255 && (g = 255);
    g < 0 && (g = 0);
    let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
    b > 255 && (b = 255);
    b < 0 && (b = 0);
    return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
  } else {
    return hexColor;
  }
}

function buildChart () {
  let root = am5.Root.new("chartDiv");

  root.setThemes([
    am5themes_Animated.new(root)
  ]);

  chart = root.container.children.push(am5percent.PieChart.new(root, {
    layout: root.verticalLayout,
    radius: am5.percent(100)
  }));
  innerSeries = chart.series.push(am5percent.PieSeries.new(root, {
    valueField: "value",
    categoryField: "name",
    alignLabels: false,
    radius: am5.percent(80),
    innerRadius: am5.percent(25)
  }));

  innerSeries.ticks.template.setAll({ forceHidden: true });

  innerSeries.labels.template.setAll({
    radius: -4,
    text: "{category}",
    textType: "radial",
    fontSize: 12,
    fontWeight: 600,
    centerX: am5.percent(100)
  });

  innerSeries.slices.template.setAll({
    stroke: am5.color('#102535'),
    strokeWidth: 2,
    templateField: "settings",
    tooltipText: "[fontSize: 14px;bold]{category}:[/] [fontSize: 14px]{value} h ({valuePercentTotal.formatNumber('.##')}%)[/]"
  });
  innerSeries.slices.template.states.create("hover", { scale: 0.95 });

  outerSeries = chart.series.push(am5percent.PieSeries.new(root, {
    valueField: "value",
    categoryField: "name",
    alignLabels: true,
    innerRadius: am5.percent(80),
    radius: am5.percent(100)
  }));

  outerSeries.slices.template.setAll({
    stroke: am5.color('#102535'),
    strokeWidth: 2,
    templateField: "settings",
    tooltipText: "[fontSize: 14px;bold]{category}:[/]\n[fontSize: 14px]{value} h ({valuePercentTotal.formatNumber('.##')}%)[/]"
  });

  outerSeries.ticks.template.setAll({ forceHidden: true });

  outerSeries.labels.template.setAll({ forceHidden: true })

  innerSeries.data.setAll(innerChartData.value);
  outerSeries.data.setAll(outerChartData.value);
  innerSeries.appear(1000, 100);
  outerSeries.appear(1000, 100);

  chartLabel = innerSeries.children.push(
    am5.Label.new(root, {
      text: "No data",
      fontSize: 14,
      textAlign: "center",
      centerX: am5.percent(50),
      centerY: am5.percent(50),
      fill: "#ffffff",
    })
  );
}

function syncChartData () {
  innerSeries.data.setAll(innerChartData.value)
  outerSeries.data.setAll(outerChartData.value)
  chartLabel.set("text", totalHours.value || budget.value ? (budget.value ? Math.round(totalHours.value / budget.value * 10000) / 100 + '%' : totalHours.value + ' h') : 'No data')
  chartLabel.set("fill", budget.value && totalHours.value > budget.value ? am5.color('#f87171') : am5.color('#ffffff'))
  chartLabel.set("fontWeight", budget.value && totalHours.value > budget.value ? 600 : 400)
}

function updateIncludeDED () {
  isIncludeDED.value = !isIncludeDED.value
  courseWeeks.value = 0
  media.value.bqa = 0
  media.value.bhp = 0
  media.value.bcr = 0
  updateURL()
}

// watch for userData, budget or courseWeek changes and save it automatically to the URI
watch([media, budget, courseWeeks, courseName], () => {
    syncChartData();
    updateURL();
  }, { deep: true }
);

onMounted(() => {
  buildChart();
  loadURI();
});
</script>

<style>
.vcp__header {
  height: auto !important;
  background: #eeeeee !important;
  border: none !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.vcp__body {
  background: none !important;
  border: 2px solid #eeeeee !important;
}

.vcp {
  margin-bottom: 1em !important;
}


.panel {
  margin-bottom: 0.5em;
  border-radius: 5px;
}

.panelGroup {
  border: 0 !important;
}

.barContainer {
  background: #0a1721;
  height: 15px;
  width: 150px;
  border-radius: 20px;
  margin-bottom: 6px;
  margin-right: 10px;
}

.barFill {
  background: #99bdd7;
  height: 15px;
  border-radius: 20px;
  max-width: 100%;
  transition: all 0.5s ease-in-out;
}

div.overBudget {
  background: #e66667;
}

div.caution {
  background: #ffa423;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from {
  transform: translateX(100px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-100px);
  opacity: 0;
}

.activeStage {
  background: #005a9c !important;
  color: #fff;
}

.completeStage {
  background: #a7d5b9 !important;
  color: #22964f;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.calcInput {
  padding: 0;
  display: inline-block;
  text-align: center;
  font-size: 3em;
  line-height: 1;
  background: none !important;
  margin: 0 1rem !important;
  width: 100%;
  color: #005a9c !important;
  border-radius: 4px !important;
  font-weight: 700;
  font-family: "Made Evolve Sans", sans-serif !important;
}

.listInput {
  padding: 0;
  display: inline-block;
  text-align: center;
  background: none !important;
  border: none !important;
  margin: 0 !important;
  width: 100%;
  color: #005a9c !important;
  font-weight: 700;
  font-family: "Made Evolve Sans", sans-serif !important;
}

.panel h3 {
  background: none !important;
  color: #102535;
}

.sidebar h2 {
  color: white !important;
  margin-top: 1em;
  margin-left: 1em;
}

.sidebar {
  padding-top: 1em;
  max-width: 350px;
  overflow: scroll;
  height: 100vh;
  padding-bottom: 1em;
}

/* hide input number arrows in FireFox */
input[type="number"] {
  -moz-appearance: textfield;
}

@media (max-width: 1024px) {
  .sidebar {
    display: flex;
    flex-wrap: wrap;
    height: inherit !important;
    max-width: 100%;
  }
}
</style>
